import { render } from "./InstruccionesMultiSelect.vue?vue&type=template&id=3d3d57b7&scoped=true"
import script from "./InstruccionesMultiSelect.vue?vue&type=script&lang=js"
export * from "./InstruccionesMultiSelect.vue?vue&type=script&lang=js"

import "./InstruccionesMultiSelect.vue?vue&type=style&index=0&id=3d3d57b7&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3d57b7"]])

export default __exports__